
import './App.css';
import Footer from './Component/Footer';
import Header from './Component/Header';
import Body from './Component/Body';
import bookimg from "./Component/bookimg.jpg"
import aeimg from "./Component/aeimg.jpg"
import eceimg from "./Component/eceimg.jpg"
import cseimg from "./Component/cseimg.jpg"
import book1img from "./Component/book1img.jpg"

import About from './Component/About';
import CSE from './Component/CSE';
import ECE from './Component/ECE';
import AE from './Component/AE';
import Contact from './Component/Contact';
import Terms from './Component/Terms';
import Copyright from './Component/Copyright';
import {
  //CSE
  Ob,Evs,Dm,Coa,Dbms,Oops,ComLab,DbmsLab,OopsLab,Ec, M_2,Pfps,Bee,BeeLab
  ,ENG_2,EcLab,CLab,Ep,M_1,Egd,Peng,EpLab,Wpm,M_3,Etc,Aec,Ds,De,Mp,AecLab,
  DsLab,DeLab,M_4,Coi,Py,Daa,Os,Fl,DaaLab,OsLab,Cd,Cn,Se,CdLab,CnLab,ETCH_2,
  //ECE
  Ma_3,Ed, EdLab,Dsd,DsdLab,Ss,Nt,NtLab,Be,//3rd sem
Adc,AdcLab,Aece,AeceLab,Mm,MmLab,Mt,Ese, //4th sem
Emw,EmwLab,Ca,Ptsp,Dsp,DspLab,Orim,//5th sem
Cs,Cnk,CnkLab,Eim,Ucs,//6th sem
Awp //7th sem
//AE
,MA_3,Beea,Em,Fm,Td,FmLab,Awi,//3rd
Sm,Sl,Ssm,Pho,Fp,SlLab,SsmLab,FpLab,PhoLab,//4th
ORim,Ktm,Wh,Fmy,Mofp,Ret,WhLab,FmyLab,MofpLab,RetLab//5th
,Tofp,Mdd,Swce,Ide,TofpLab,MddLab,SwceLab,IdeLab,//6th
Lwrm,Fvp//7th
} from './Component/index1';

import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

function App() {
  return(
    <>
       <BrowserRouter>
       <Header/>
       <Routes>
       <Route path="/" element={ 
       <div className='container '>
         <About img={bookimg} title="Departments"/>
          <div className=" mx-2 my-3 row">
            <div className="col-md-4" >
            <Body title="CSE" img={cseimg} ink="/CSE" dept="Dept. of Computer Science & Engneering" />
            </div>
            <div className="col-md-4 ">
              <Body title="ECE" img={eceimg} ink="ECE" dept="Dept. of Electronics & Communication Engg."/>
            </div>
            <div className="col-md-4">
              <Body title="AE" img={aeimg} ink="AE" dept="Dept. of Agricultural Engineering" />
            </div>
          </div>
          </div>
        }/>
       
       <Route path="*" element={ 
       <div className='container '>
         <About img={bookimg} title="Departments"/>
          <div className=" mx-5 my-3 row">
            <div className="col-md-4" >
            <Body title="CSE" img={cseimg} ink="/CSE" dept="Dept. of Computer Science & Engneering" />
            </div>
            <div className="col-md-4 ">
              <Body title="ECE" img={eceimg} ink="ECE" dept="Dept. of Electronics & Communication Engg."/>
            </div>
            <div className="col-md-4">
              <Body title="AE" img={aeimg} ink="AE" dept="Dept. of Agriculture Engineering" />
            </div>
          </div>
          </div>
        }/>
       <Route path="/ECE" element={<ECE title="ECE"/>}/>
       <Route path="/AE" element={<AE />}/>
       <Route path="/CSE" element={<CSE title="CSE"/>}/>
       <Route path="/Contact" element={<Contact />}/>
       <Route path="/Terms" element={<Terms />}/>
       <Route path="/Copyright" element={<Copyright />}/>
       
       <Route path="/CSE/Ob" element={<Ob/>}/>
       <Route path="/CSE/Evs" element={<Evs/>}/>
       <Route path="/CSE/Dm" element={<Dm/>}/>
       <Route path="/CSE/Coa" element={<Coa/>}/>
       <Route path="/CSE/Dbms" element={<Dbms/>}/>
       <Route path="/CSE/Oops" element={<Oops/>}/>
       <Route path="/CSE/ComLab" element={<ComLab/>}/>
       <Route path="/CSE/DbmsLab" element={<DbmsLab/>}/>
       <Route path="/CSE/OopsLab" element={<OopsLab/>}/>
       <Route path="/CSE/Ec" element={<Ec/>}/>
       <Route path="/CSE/M_2" element={< M_2/>}/>
       <Route path="/CSE/Pfps" element={< Pfps/>}/>
       <Route path="/CSE/Bee" element={< Bee />}/>
       <Route path="/CSE/BeeLab" element={< BeeLab/>}/>
       <Route path="/CSE/ENG_2" element={< ENG_2/>}/>
       <Route path="/CSE/EcLab" element={< EcLab/>}/>
       <Route path="/CSE/CLab" element={< CLab/>}/>
       <Route path="/CSE/Ep" element={< Ep/>}/>
       <Route path="/CSE/M_1" element={< M_1/>}/>
       <Route path="/CSE/Egd" element={< Egd/>}/>
       <Route path="/CSE/Peng" element={< Peng/>}/>
       <Route path="/CSE/EpLab" element={< EpLab/>}/>
       <Route path="/CSE/Wpm" element={< Wpm/>}/>
       <Route path="/CSE/M_3" element={< M_3/>}/>
       <Route path="/CSE/Etc" element={< Etc/>}/>
       <Route path="/CSE/Aec" element={<Aec/>}/>
       <Route path="/CSE/Ds" element={< Ds/>}/>
       <Route path="/CSE/De" element={< De/>}/>
       <Route path="/CSE/Mp" element={< Mp/>}/>
       <Route path="/CSE/AecLab" element={< AecLab/>}/>
       <Route path="/CSE/DsLab" element={< DsLab/>}/>
       <Route path="/CSE/DeLab" element={< DeLab/>}/>
       <Route path="/CSE/M_4" element={< M_4/>}/>
       <Route path="/CSE/Coi" element={< Coi/>}/>
       <Route path="/CSE/Py" element={< Py/>}/>
       <Route path="/CSE/Daa" element={< Daa/>}/>
       <Route path="/CSE/Os" element={< Os/>}/>
       <Route path="/CSE/Fl" element={< Fl/>}/>
       <Route path="/CSE/DaaLab" element={< DaaLab/>}/>
       <Route path="/CSE/OsLab" element={< OsLab/>}/>
       <Route path="/CSE/Cd" element={< Cd/>}/>
       <Route path="/CSE/Cn" element={< Cn/>}/>
       <Route path="/CSE/Se" element={< Se/>}/>
       <Route path="/CSE/CdLab" element={< CdLab/>}/>
       <Route path="/CSE/CnLab" element={< CnLab/>}/>
       <Route path="/CSE/ETCH_2" element={< ETCH_2/>}/>
       {/* ECE */}
       <Route path="/ECE/Ma_3" element={< Ma_3 />}/>
       <Route path="/ECE/Ed" element={< Ed />}/>
       <Route path="/ECE/EdLab" element={<EdLab/>}/>
       <Route path="/ECE/Dsd" element={< Dsd />}/>
       <Route path="/ECE/DsdLab" element={< DsdLab />}/>
       <Route path="/ECE/Ss" element={< Ss />}/>
       <Route path="/ECE/Nt" element={<Nt  />}/>
       <Route path="/ECE/NtLab" element={< NtLab />}/>
       <Route path="/ECE/Be" element={< Be />}/>
       <Route path="/ECE/Adc" element={< Adc />}/>
       <Route path="/ECE/AdcLab" element={< AdcLab />}/>
       <Route path="/ECE/Aece" element={< Aece />}/>
       <Route path="/ECE/AeceLab" element={< AeceLab />}/>
       <Route path="/ECE/Mm" element={< Mm />}/>
       <Route path="/ECE/MmLab" element={< MmLab />}/>
       <Route path="/ECE/Mt" element={< Mt />}/>
       <Route path="/ECE/Ese" element={< Ese />}/>
       <Route path="/ECE/Emw" element={< Emw />}/>
       <Route path="/ECE/EmwLab" element={< EmwLab />}/>
       <Route path="/ECE/Ca" element={< Ca />}/>
       <Route path="/ECE/Ptsp" element={< Ptsp />}/>
       <Route path="/ECE/Dsp" element={< Dsp />}/>
       <Route path="/ECE/DspLab" element={< DspLab />}/>
       <Route path="/ECE/Orim" element={< Orim />}/>
       <Route path="/ECE/Cs" element={< Cs />}/>
       <Route path="/ECE/Cnk" element={< Cnk />}/>
       <Route path="/ECE/CnkLab" element={< CnkLab />}/>
       <Route path="/ECE/Eim" element={< Eim />}/>
       <Route path="/ECE/Ucs" element={< Ucs />}/>
       <Route path="/ECE/Awp" element={< Awp />}/>
       {/* AE */}
       <Route path="/AE/MA_3" element={< MA_3 />}/>
       <Route path="/AE/Beea" element={< Beea />}/>
       <Route path="/AE/Em" element={< Em />}/>
       <Route path="/AE/Fm" element={< Fm />}/>
       <Route path="/AE/Td" element={< Td />}/>
       <Route path="/AE/FmLab" element={< FmLab />}/>
       <Route path="/AE/Awi" element={< Awi />}/>
       <Route path="/AE/Sm" element={< Sm />}/>
       <Route path="/AE/Sl" element={< Sl />}/>
       <Route path="/AE/Ssm" element={< Ssm />}/>
       <Route path="/AE/Fp" element={<Fp  />}/>
       <Route path="/AE/Pho" element={< Pho />}/>
       <Route path="/AE/SlLab" element={< SlLab />}/>
       <Route path="/AE/SsmLab" element={< SsmLab />}/>
       <Route path="/AE/FpLab" element={< FpLab />}/>
       <Route path="/AE/PhoLab" element={< PhoLab />}/>
       <Route path="/AE/ORim" element={< ORim />}/>
       <Route path="/AE/Ktm" element={<Ktm  />}/>
       <Route path="/AE/Wh" element={< Wh />}/>
       <Route path="/AE/Fmy" element={<Fmy  />}/>
       <Route path="/AE/Mofp" element={< Mofp />}/>
       <Route path="/AE/Ret" element={< Ret />}/>
       <Route path="/AE/WhLab" element={< WhLab />}/>
       <Route path="/AE/FmyLab" element={< FmyLab />}/>
       <Route path="/AE/MofpLab" element={< MofpLab />}/>
       <Route path="/AE/RetLab" element={< RetLab />}/>
       <Route path="/AE/Tofp" element={< Tofp />}/>
       <Route path="/AE/Mdd" element={< Mdd />}/>
       <Route path="/AE/Swce" element={< Swce />}/>
       <Route path="/AE/Ide" element={< Ide />}/>
       <Route path="/AE/TofpLab" element={< TofpLab />}/>
       <Route path="/AE/MddLab" element={< MddLab />}/>
       <Route path="/AE/SwceLab" element={< SwceLab />}/>
       <Route path="/AE/IdeLab" element={< IdeLab />}/>
       <Route path="/AE/Lwrm" element={< Lwrm />}/>
       <Route path="/AE/Fvp" element={< Fvp />}/>

       
      <Route path="/About" element={<About img={book1img} />}/>
       </Routes>
       <Footer/>
       </BrowserRouter>
        
    </>
  );
 
}

export default App;
